import {useEffect, useState} from 'react';
import {getManifestationFileInfo} from 'api';
import {useGetTokens} from 'services/auth';

export const useGetManifestationFileInfo = (ean?: string) => {
  const getTokens = useGetTokens();

  const [hasFile, setHasFile] = useState<boolean>(false);

  useEffect(() => {
    if (ean) {
      getManifestationFileInfo(ean, getTokens).then(r =>
        setHasFile(r.hasFile === true),
      );
    }
  }, [ean, getTokens]);

  return hasFile;
};
